import reportQuery from './view/reportQuery.html'

export default {
  base: {
    state: 'declaration.vatDeclarationSurcharges.reportQuery',
    config: {
      url: '/reportQuery',
      abstract: true,
      template: '<div ui-view></div>',
      default: 'declaration.vatDeclarationSurcharges.reportQuery.list',
      title: '申报表报表查询',
    },
  },
  list: {
    state: 'declaration.vatDeclarationSurcharges.reportQuery.list',
    config: {
      url: '/list',
      template: reportQuery,
      controller: 'reportQueryCtrl',
    },
  },
}



// WEBPACK FOOTER //
// ./src/app/declaration/vatDeclarationSurcharges/reportQuery/routers.js